import styled, { css } from 'styled-components';

import { StyledTd, StyledTh } from 'components/ui/Table/Table.styles';
import { ActionButton } from 'components/ui/Button';
import { Row } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const CoachSeatButton = styled(ActionButton)`
  display: inline-block;
  padding: 0;
  width: 90%;
  margin: 0;
  ${(props) =>
    props.isConflicted &&
    css`
      background-color: ${colours.Messaging.ErrorRed};
      border-color: ${colours.Messaging.ErrorRed};
    `}
`;

export const CoachSeatLabel = styled.span`
  font-size: clamp(10px, 1.2vw, 16px);
`;

export const NoSeat = styled.div`
  div {
    width: 50%;
    display: inline-block;
    text-align: center;
  }
`;

export const StyledRow = styled(Row)`
  ${StyledTd},
  ${StyledTh} {
    padding: 0.4em 0.3em;
  }
`;

export const CostPriceTooltip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DependantTooltip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const StatusTooltip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
`;

export const StatusTicket = styled.span`
  color: ${({ color }) => color ?? 'black'};
`;
